import shajs from 'sha.js';

export const MAX_LENGTH = 24;
export const MIN_LENGTH = 10;

let count = 0;
/**
 * Generate a unique string
 * @param {number} length
 * @param {number} minLength
 * @param {number} maxLength
 */
export const getUnique = (
  length: number,
  minLength: number = MIN_LENGTH,
  maxLength: number = MAX_LENGTH,
): string => {
  if (length < minLength || length > maxLength) {
    throw new Error(`Must provide a length between ${minLength} and ${maxLength}`);
  }

  const hash = `${Date.now()}${count}`; // ensure a unique value
  count += 1;

  return shajs('sha256').update(hash).digest('hex').slice(0, length);
};
